import React, { useState } from "react";
import CustomButton from "../components/common/CustomButton";
import CustomInput from "../components/common/CustomInput";
import { COLORS } from "../constants/colors.js";
import { FONTS } from "../constants/fonts.js";
import { useAuth } from "../context/AuthContext";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/24/outline";

const styles = {
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundImage: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.tertiary} 100%)`,
    padding: "16px 24px",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    margin: 0,
  },
  card: {
    backgroundColor: `${COLORS.white}cc`,
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    padding: 40,
    borderRadius: 16,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    border: `1px solid ${COLORS.secondary}`,
    width: "100%",
    maxWidth: 480,
    animation: "fadeIn 0.5s ease-in-out",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
    },
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 32,
  },
  logo: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: COLORS.secondary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: `0 4px 12px rgba(${parseInt(
      COLORS.primary.slice(1, 3),
      16
    )}, ${parseInt(COLORS.primary.slice(3, 5), 16)}, ${parseInt(
      COLORS.primary.slice(5, 7),
      16
    )}, 0.2)`,
  },
  logoIcon: {
    color: COLORS.primary,
  },
  title: {
    fontSize: 32,
    fontFamily: FONTS.bold,
    color: COLORS.text,
    textAlign: "center",
    marginBottom: 32,
    fontWeight: 700,
  },
  button: {
    marginTop: 24,
    borderRadius: 12,
  },
  "@keyframes fadeIn": {
    "0%": { opacity: 0, transform: "translateY(20px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
  "@media (max-width: 480px)": {
    container: {
      padding: "12px 16px",
    },
    card: {
      padding: 24,
      maxWidth: "90%",
    },
    title: {
      fontSize: 28,
    },
  },
};

const LoginScreen = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, setUserType, setUser } = useAuth();

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please enter both email and password");
      return;
    }
    if (email === "admin" && password === "admin") {
      setUserType("admin");
      setUser({ userType: "admin" });
      return;
    }
    setLoading(true);
    try {
      await login(email, password);
      console.log("logged in");
    } catch (error) {
      alert("Login Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoContainer}>
          <div style={styles.logo}>
            <ArrowRightOnRectangleIcon
              width={40}
              height={40}
              style={styles.logoIcon}
            />
          </div>
        </div>
        <h1 style={styles.title}>Welcome Back</h1>
        <CustomInput
          value={email}
          onChangeText={setEmail}
          icon={
            <ArrowRightOnRectangleIcon
              width={24}
              height={24}
              stroke={COLORS.primary}
            />
          }
          placeholder="Enter your email"
          type="email"
          error={
            email && email !== "admin" && !email.includes("@")
              ? "Please enter a valid email address"
              : ""
          }
        />
        <CustomInput
          value={password}
          onChangeText={setPassword}
          secureTextEntry={true}
          icon={
            <ArrowRightOnRectangleIcon
              width={24}
              height={24}
              stroke={COLORS.primary}
            />
          }
          placeholder="Enter your password"
        />
        <CustomButton
          title={loading ? "Logging in..." : "Sign In"}
          onPress={handleLogin}
          style={styles.button}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default LoginScreen;
